var _g, _path, _path2, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 208,
    viewBox: "0 0 209 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 108.483,
    r: 90.2535,
    fill: "#EA2A2A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4159 62.9892C74.3368 60.5428 86.9108 57.4169 97.4567 63.8047C102.73 66.9306 110.571 72.6388 124.092 64.4842C130.987 60.1351 145.184 56.1937 156 70.6002C161.003 77.2598 166.005 95.1999 157.217 109.47C152.485 117.217 142.074 128.906 139.505 143.176C137.883 152.282 132.475 165.465 124.362 168.32C121.523 169.407 114.628 170.63 114.357 161.252C114.357 161.252 114.763 154.457 107.597 153.098C107.597 153.098 100.837 152.962 100.296 160.301C99.8904 166.825 92.9949 168.999 86.5052 163.835C80.9618 159.35 77.7169 152.01 76.7705 141.273C76.3648 136.517 73.3904 129.585 69.4694 123.877C63.3853 115.043 41.8878 81.0653 70.4159 62.9892Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.092 64.485C110.707 72.6396 102.865 66.9314 97.4572 63.8055C95.2939 62.4464 92.9955 61.6309 90.697 61.0873C79.3398 59.4563 80.2863 69.9214 89.0745 72.2319C104.353 75.9015 113.411 70.7369 124.092 64.485Z",
    fill: "#E6E7E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.496,
    y: 92.5105,
    width: 7.74602,
    height: 37.432,
    rx: 2,
    transform: "rotate(45 119.496 92.5105)",
    fill: "#EA2A2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124.973,
    y: 118.979,
    width: 7.74602,
    height: 37.432,
    rx: 2,
    transform: "rotate(135 124.973 118.979)",
    fill: "#EA2A2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0.746582,
    y: 0.22998,
    width: 207.507,
    height: 207.507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.40098c95b88aaa00452f8ebc015cb1e4.svg";
export { ForwardRef as ReactComponent };